import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { api, ApiError } from '../api';
import { GearLink } from '../ui/GearLink';
import { InboxList } from './Bell';
import { NOTIFICATIONS_KEY, useOpenNotification, type Inbox } from './types';

/** All my in-app notifications: unread first, then newest. Opening one marks it read and follows its link. */
export function InboxPage() {
  const inbox = useQuery({ queryKey: [...NOTIFICATIONS_KEY, 'all'], queryFn: () => api<Inbox>('/api/me/notifications') });
  const openMessage = useOpenNotification();
  const items = inbox.data?.notifications ?? [];
  return (
    <section className="page" data-feature-id="notifications.inbox">
      <div className="page-head">
        <h1>Powiadomienia</h1>
        <GearLink to="/moje-konto" label="Ustawienia powiadomień (telefon, komputer)" />
      </div>
      <p className="lede">
        Zmiany, które Cię dotyczą. Kliknij wiadomość, żeby przejść do sprawy. Powiadomienia na telefon i komputer włączysz w <Link to="/moje-konto">Moim koncie</Link>.
      </p>
      {inbox.isLoading && <p className="muted" role="status">Wczytywanie…</p>}
      {inbox.error && <p className="alert" role="alert">{inbox.error instanceof ApiError ? inbox.error.message : 'Nie udało się wczytać powiadomień'}</p>}
      {inbox.data && items.length === 0 && <p className="muted">Nie masz jeszcze powiadomień.</p>}
      {items.length > 0 && (
        <InboxList items={items} onOpen={openMessage} className="inbox-page" />
      )}
    </section>
  );
}
